/* eslint-disable no-alert */
import React from 'react'
import _ from 'lodash'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import { Header, Segment, Grid, Button, Icon, Divider, Loader } from 'semantic-ui-react'

import ModalNewItemForm from './forms/newItemForm'
import DealItem from './dealItem'

import RestaurantActions from '../../reducers/restaurantReducer'
import SpecialDealActions from '../../reducers/specialDealReducer'

class DealDetail extends React.PureComponent {
  state = {
    formVisible: false,
    item: null,
    action: '',
    specialDealData: null,
    mounted: false,
  }

  static getDerivedStateFromProps(props, state) {
    const { specialDealData } = state
    const { specialDeals: propsSpecialDeals, history } = props
    const specialDealKey = history.location.state.specialDealData.key || null

    if (specialDealData !== propsSpecialDeals[specialDealKey]) {
      return { specialDealData: propsSpecialDeals[specialDealKey] }
    }

    return null
  }

  async componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, history, specialDeals, getSpecialDeals, syncSpecialDeal } = this.props
    const currentDealKey = history.location.state.specialDealData.key

    if (!specialDeals.data) {

      getSpecialDeals()
      this.setState({ specialDealData: specialDeals[currentDealKey], mounted: true })
    }

    if (!restaurantLoaded) fetchRestaurants()
    syncSpecialDeal(currentDealKey)
  }

  componentWillUnmount() {
    const { unSyncSpecialDeal } = this.props

    unSyncSpecialDeal()
  }

  onSoldItemEdit = async itemKey => {
    const { match } = this.props
    const { specialDealData } = this.state
    const specialDealKey = _.get(match, 'params.id')

    const { sold } = specialDealData.items[itemKey]
    const newSoldAmount = window.prompt('Please input expected sold amount', sold)

    if (newSoldAmount || newSoldAmount === '0') {
      await firebase
        .firestore()
        .collection('special_deals')
        .doc(specialDealKey)
        .update({
          [`items.${itemKey}.sold`]: Number(newSoldAmount)
        })
    }
  }

  onEdit = item => {
    this.setState({ item, formVisible: true, action: 'edit' })
  }

  onDelete = async item => {
    const { match, deleteDealItem } = this.props
    const { specialDealData } = this.state

    const specialDealKey = _.get(match, 'params.id')
    const items = _.get(specialDealData, 'items', [])

    const remainingItems = _.filter(items, i => i.key !== item.key)
    const remainingMerchantIds = remainingItems.map(i => i.merchant_id)

    const confirm = window.confirm(`Are you sure you want to delete this item?`)
    const specialDealRef = firebase.firestore().collection('special_deals')

    const updates = {}

    if (confirm) {
      if (!remainingMerchantIds.includes(item.merchant_id)) {
        updates.merchant_ids = {
          [item.merchant_id]: firebase.firestore.FieldValue.delete()
        }
      }

      updates.items = {
        [item.key]: firebase.firestore.FieldValue.delete()
      }

      await specialDealRef.doc(specialDealKey).set(updates, { merge: true })
      deleteDealItem(specialDealKey, item.key)
    }
  }

  renderItemRow = () => {
    const { specialDealData } = this.state
    const { restaurants } = this.props

    const specialDealItems = _.get(specialDealData, 'items', [])

    return _.map(specialDealItems, (item, key) => (
      <DealItem
        key={key}
        restaurants={restaurants}
        item={item}
        onSoldItemEdit={() => this.onSoldItemEdit(key)}
        onDelete={() => this.onDelete(item)}
        onEdit={() => this.onEdit(item)}
      />
    ))
  }

  render() {
    const { formVisible, action, item, specialDealData, mounted } = this.state
    const { restaurantLoaded, restaurants, match } = this.props
    const merchantIds = _.get(specialDealData, 'merchant_ids', {})

    if (restaurantLoaded && mounted) {
      return (
        <div>
          <Grid>
            <Grid.Column width="16">
              <Segment color="black">
                <Header size="large" style={{ display: 'inline-block', marginBottom: 0 }}>
                  {`Special Deal Items (${_.size(specialDealData.items)})`}
                </Header>
                <div style={{ float: 'right' }}>
                  <Button
                    icon
                    color="black"
                    onClick={() => this.setState({ action: 'new', formVisible: true })}
                  >
                    <Icon name="add" /> Add New
                  </Button>
                </div>

                <div>
                  <Divider style={{ margin: 14 }} />
                </div>

                <div style={{ overflow: 'auto' }}>{this.renderItemRow()}</div>

                {formVisible && (
                  <ModalNewItemForm
                    specialDealKey={_.get(match, 'params.id')}
                    item={item}
                    action={action}
                    merchantIds={merchantIds}
                    restaurants={restaurants}
                    onClose={() => this.setState({ formVisible: false, action: '', item: null })}
                  />
                )}
              </Segment>
            </Grid.Column>
          </Grid>
        </div>
      )
    }

    return (
      <React.Fragment>
        <Loader active />
      </React.Fragment>
    )
  }
}

const mapState = ({ restaurants, specialDeals }) => ({
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,
  specialDeals: specialDeals.data,
})

const mapDispatch = {
  syncSpecialDeal: SpecialDealActions.syncSpecialDeal,
  unSyncSpecialDeal: SpecialDealActions.unSyncSpecialDeal,
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getSpecialDeals: SpecialDealActions.getSpecialDeals,
  deleteDealItem: SpecialDealActions.deleteDealItem,
}

export default connect(
  mapState,
  mapDispatch
)(DealDetail)



// WEBPACK FOOTER //
// ./src/components/specialDeal/dealDetail.js